export enum LanguageCode {

    /**
     * Afrikaans (South Africa)
     */
    afZA = 'af-ZA',

    /**
     * Arabic (U.A.E.)
     */
    arAE = 'ar-AE',

    /**
     * Arabic (Bahrain)
     */
    arBH = 'ar-BH',

    /**
     * Arabic (Algeria)
     */
    arDZ = 'ar-DZ',

    /**
     * Arabic (Egypt)
     */
    arEG = 'ar-EG',

    /**
     * Arabic (Iraq)
     */
    arIQ = 'ar-IQ',


    /**
     * Arabic (Jordan)
     */
    arJO = 'ar-JO',

    /**
     * Arabic (Kuwait)
     */
    arKW = 'ar-KW',

    /**
     * Arabic (Lebanon)
     */
    arLB = 'ar-LB',

    /**
     * Arabic (Libya)
     */
    arLY = 'ar-LY',

    /**
     * Arabic (Morocco)
     */
    arMA = 'ar-MA',

    /**
     * Arabic (Oman)
     */
    arOM = 'ar-OM',

    /**
     * Arabic (Qatar)
     */
    arQA = 'ar-QA',

    /**
     * Arabic (Saudi Arabia)
     */
    arSA = 'ar-SA',

    /**
     * Arabic (Syria)
     */
    arSY = 'ar-SY',

    /**
     * Arabic (Tunisia)
     */
    arTN = 'ar-TN',

    /**
     * Arabic (Yemen)
     */
    arYE = 'ar-YE',

    /**
     * Mapudungun (Chile)
     */
    arnCL = 'arn-CL',

    /**
     * Assamese (India)
     */
    asIN = 'as-IN',

    /**
     * Azeri
     */
    az = 'az',


    /**
     * Azeri (Cyrillic) (Azerbaijan)
     */
    azCyrlAZ = 'az-Cyrl-AZ',

    /**
     * Azeri (Latin) (Azerbaijan)
     */
    azLatnAZ = 'az-Latn-AZ',

    /**
     * Bashkir (Russia)
     */
    baRU = 'ba-RU',

    /**
     * Belarusian
     */
    be = 'be',

    /**
     * Belarusian (Belarus)
     */
    beBY = 'be-BY',

    /**
     * Bulgarian (Bulgaria)
     */
    bgBG = 'bg-BG',

    /**
     * Bengali (Bangladesh)
     */
    bnBD = 'bn-BD',

    /**
     * Bengali (India)
     */
    bnIN = 'bn-IN',

    /**
     * Tibetan (People's Republic of China)
     */
    boCN = 'bo-CN',

    /**
     * Breton (France)
     */
    brFR = 'br-FR',

    /**
     * Bosnian (Cyrillic) (Bosnia and Herzegovina)
     */
    bsCyrlBA = 'bs-Cyrl-BA',

    /**
     * Bosnian (Latin) (Bosnia and Herzegovina)
     */
    bsLatnBA = 'bs-Latn-BA',

    /**
     * Catalan
     */
    ca = 'ca',

    /**
     * Catalan (Catalan)
     */
    caES = 'ca-ES',

    /**
     * Corsican (France)
     */
    coFR = 'co-FR',

    /**
     * Czech
     */
    cs = 'cs',

    /**
     * Czech (Czech Republic)
     */
    csCZ = 'cs-CZ',

    /**
     * Welsh (United Kingdom)
     */
    cyGB = 'cy-GB',

    /**
     * Danish
     */
    da = 'da',

    /**
     * Danish (Denmark)
     */
    daDK = 'da-DK',

    /**
     * German (Germany)
     */
    deDE = 'de-DE',

    /**
     * German (Austria)
     */
    deAT = 'de-AT',

    /**
     * German (Switzerland)
     */
    deCH = 'de-CH',

    /**
     * German (Liechtenstein)
     */
    deLI = 'de-LI',

    /**
     * German (Luxembourg)
     */
    deLU = 'de-LU',

    /**
     * Lower Sorbian (Germany)
     */
    dsbDE = 'dsb-DE',

    /**
     * Divehi
     */
    dv = 'dv',

    /**
     * Divehi (Maldives)
     */
    dvMV = 'dv-MV',

    /**
     * Greek
     */
    el = 'el',

    /**
     * Greek (Greece)
     */
    elGR = 'el-GR',

    /**
     * English
     */
    en = 'en',

    /**
     * English (Caribbean)
     */
    en029 = 'en-029',

    /**
     * English (Australia)
     */
    enAU = 'en-AU',

    /**
     * English (Belize)
     */
    enBZ = 'en-BZ',

    /**
     * English (Canada)
     */
    enCA = 'en-CA',

    /**
     * English (United Kingdom)
     */
    enGB = 'en-GB',

    /**
     * English (Ireland)
     */
    enIE = 'en-IE',

    /**
     * English (India)
     */
    enIN = 'en-IN',

    /**
     * English (Jamaica)
     */
    enJM = 'en-JM',

    /**
     * English (Malaysia)
     */
    enMY = 'en-MY',

    /**
     * English (New Zealand)
     */
    enNZ = 'en-NZ',

    /**
     * English (Republic of the Philippines)
     */
    enPH = 'en-PH',

    /**
     * English (Singapore)
     */
    enSG = 'en-SG',

    /**
     * English (Trinidad and Tobago)
     */
    enTT = 'en-TT',

    /**
     * English (United States)
     */
    enUS = 'en-US',

    /**
     * English (South Africa)
     */
    enZA = 'en-ZA',

    /**
     * English (Zimbabwe)
     */
    enZW = 'en-ZW',

    /**
     * Spanish
     */
    es = 'es',

    /**
     * Spanish (Argentina)
     */
    esAR = 'es-AR',

    /**
     * Spanish (Bolivia)
     */
    esBO = 'es-BO',

    /**
     * Spanish (Chile)
     */
    esCL = 'es-CL',

    /**
     * Spanish (Colombia)
     */
    esCO = 'es-CO',

    /**
     * Spanish (Costa Rica)
     */
    esCR = 'es-CR',

    /**
     * Spanish (Dominican Republic)
     */
    esDO = 'es-DO',

    /**
     * Spanish (Ecuador)
     */
    esEC = 'es-EC',

    /**
     * Spanish (Spain)
     */
    esES = 'es-ES',

    /**
     * Spanish (Guatemala)
     */
    esGT = 'es-GT',

    /**
     * Spanish (Honduras)
     */
    esHN = 'es-HN',

    /**
     * Spanish (Mexico)
     */
    esMX = 'es-MX',

    /**
     * Spanish (Nicaragua)
     */
    esNI = 'es-NI',

    /**
     * Spanish (Panama)
     */
    esPA = 'es-PA',

    /**
     * Spanish (Peru)
     */
    esPE = 'es-PE',

    /**
     * Spanish (Puerto Rico)
     */
    esPR = 'es-PR',

    /**
     * Spanish (Paraguay)
     */
    esPY = 'es-PY',

    /**
     * Spanish (El Salvador)
     */
    esSV = 'es-SV',

    /**
     * Spanish (United States)
     */
    esUS = 'es-US',

    /**
     * Spanish (Uruguay)
     */
    esUY = 'es-UY',

    /**
     * Spanish (Venezuela)
     */
    esVE = 'es-VE',

    /**
     * Estonian
     */
    et = 'et',

    /**
     * Estonian (Estonia)
     */
    etEE = 'et-EE',

    /**
     * Basque
     */
    eu = 'eu',

    /**
     * Basque (Basque)
     */
    euES = 'eu-ES',

    /**
     * Persian
     */
    fa = 'fa',

    /**
     * Persian (Iran)
     */
    faIR = 'fa-IR',

    /**
     * Finnish
     */
    fi = 'fi',

    /**
     * Finnish (Finland)
     */
    fiFI = 'fi-FI',

    /**
     * Filipino (Philippines)
     */
    filPH = 'fil-PH',

    /**
     * Faroese
     */
    fo = 'fo',

    /**
     * Faroese (Faroe Islands)
     */
    foFO = 'fo-FO',

    /**
     * French
     */
    fr = 'fr',

    /**
     * French (Belgium)
     */
    frBE = 'fr-BE',

    /**
     * French (Canada)
     */
    frCA = 'fr-CA',

    /**
     * French (Switzerland)
     */
    frCH = 'fr-CH',

    /**
     * French (France)
     */
    frFR = 'fr-FR',


    /**
     * French (Luxembourg)
     */
    frLU = 'fr-LU',

    /**
     * French (Principality of Monaco)
     */
    frMC = 'fr-MC',

    /**
     * Frisian (Netherlands)
     */
    fyNL = 'fy-NL',

    /**
     * Irish (Ireland)
     */
    gaIE = 'ga-IE',

    /**
     * Scottish Gaelic (United Kingdom)
     */
    gdGB = 'gd-GB',

    /**
     * Galician
     */
    gl = 'gl',

    /**
     * Galician (Galician)
     */
    glES = 'gl-ES',

    /**
     * Alsatian (France)
     */
    gswFR = 'gsw-FR',

    /**
     * Gujarati
     */
    gu = 'gu',

    /**
     * Gujarati (India)
     */
    guIN = 'gu-IN',

    /**
     * Hausa (Latin) (Nigeria)
     */
    haLatnNG = 'ha-Latn-NG',

    /**
     * Hebrew
     */
    he = 'he',

    /**
     * Hebrew (Israel)
     */
    heIL = 'he-IL',

    /**
     * Hindi
     */
    hi = 'hi',

    /**
     * Hindi (India)
     */
    hiIN = 'hi-IN',

    /**
     * Croatian
     */
    hr = 'hr',

    /**
     * Croatian (Latin) (Bosnia and Herzegovina)
     */
    hrBA = 'hr-BA',

    /**
     * Croatian (Croatia)
     */
    hrHR = 'hr-HR',

    /**
     * Upper Sorbian (Germany)
     */
    hsbDE = 'hsb-DE',

    /**
     * Hungarian
     */
    hu = 'hu',

    /**
     * ungarian (Hungary)
     */
    huHU = 'hu-HU',

    /**
     * Armenian
     */
    hy = 'hy',

    /**
     * Armenian (Armenia)
     */
    hyAM = 'hy-AM',

    /**
     * Indonesian
     */
    id = 'id',

    /**
     * Indonesian (Indonesia)
     */
    idID = 'id-ID',

    /**
     * Igbo (Nigeria)
     */
    igNG = 'ig-NG',

    /**
     * Yi (People's Republic of China)
     */
    iiCN = 'ii-CN',

    /**
     * Icelandic
     */
    is = 'is',

    /**
     * Icelandic (Iceland)
     */
    isIS = 'is-IS',

    /**
     * Italian
     */
    it = 'it',

    /**
     * Italian (Switzerland)
     */
    itCH = 'it-CH',

    /**
     * Italian (Italy)
     */
    itIT = 'it-IT',

    /**
     * Inuktitut (Syllabics) (Canada)
     */
    iuCansCA = 'iu-Cans-CA',

    /**
     * Inuktitut (Latin) (Canada)
     */
    iuLatnCA = 'iu-Latn-CA',

    /**
     * Japanese
     */
    ja = 'ja',

    /**
     * Japanese (Japan)
     */
    jaJP = 'ja-JP',

    /**
     * Georgian
     */
    ka = 'ka',

    /**
     * Georgian (Georgia)
     */
    kaGE = 'ka-GE',

    /**
     * Kazakh
     */
    kk = 'kk',

    /**
     * Kazakh (Kazakhstan)
     */
    kkKZ = 'kk-KZ',

    /**
     * Greenlandic (Greenland)
     */
    klGL = 'kl-GL',

    /**
     * Khmer (Cambodia)
     */
    kmKH = 'km-KH',

    /**
     * Kannada
     */
    kn = 'kn',

    /**
     * Kannada (India)
     */
    knIN = 'kn-IN',

    /**
     * Korean
     */
    ko = 'ko',

    /**
     * Korean (Korea)
     */
    koKR = 'ko-KR',

    /**
     * Konkani
     */
    kok = 'kok',

    /**
     * Konkani (India)
     */
    kokIN = 'kok-IN',

    /**
     * Kyrgyz
     */
    ky = 'ky',

    /**
     * Kyrgyz (Kyrgyzstan)
     */
    kyKG = 'ky-KG',

    /**
     * Latin (Vatican City)
     */
    laVA = 'la-VA',

    /**
     * Luxembourgish (Luxembourg)
     */
    lbLU = 'lb-LU',

    /**
     * Lao (Lao P.D.R.)
     */
    loLA = 'lo-LA',

    /**
     * Lithuanian
     */
    lt = 'lt',

    /**
     * Lithuanian (Lithuania)
     */
    ltLT = 'lt-LT',

    /**
     * Latvian
     */
    lv = 'lv',

    /**
     * Latvian (Latvia)
     */
    lvLV = 'lv-LV',

    /**
     * Maori (New Zealand)
     */
    miNZ = 'mi-NZ',

    /**
     * Macedonian
     */
    mk = 'mk',

    /**
     * Macedonian (Former Yugoslav Republic of Macedonia)
     */
    mkMK = 'mk-MK',

    /**
     * Malayalam (India)
     */
    mlIN = 'ml-IN',

    /**
     * Mongolian
     */
    mn = 'mn',

    /**
     * Mongolian (Cyrillic) (Mongolia)
     */
    mnMN = 'mn-MN',

    /**
     * Mongolian (Traditional Mongolian) (People's Republic of China)
     */
    mnMongCN = 'mn-Mong-CN',

    /**
     * Mohawk (Canada)
     */
    mohCA = 'moh-CA',

    /**
     * Marathi
     */
    mr = 'mr',

    /**
     * Marathi (India)
     */
    mrIN = 'mr-IN',

    /**
     * Malay
     */
    ms = 'ms',

    /**
     * Malay (Brunei Darussalam)
     */
    msBN = 'ms-BN',

    /**
     * Malay (Malaysia)
     */
    msMY = 'ms-MY',

    /**
     * Maltese (Malta)
     */
    mtMT = 'mt-MT',

    /**
     * Norwegian, Bokmål (Norway)
     */
    nbNO = 'nb-NO',

    /**
     * Nepali (Nepal)
     */
    neNP = 'ne-NP',

    /**
     * Dutch
     */
    nl = 'nl',

    /**
     * Dutch (Belgium)
     */
    nlBE = 'nl-BE',

    /**
     * Dutch (Netherlands)
     */
    nlNL = 'nl-NL',

    /**
     * Norwegian, Nynorsk (Norway)
     */
    nnNO = 'nn-NO',

    /**
     * Norwegian
     */
    no = 'no',

    /**
     * Sesotho sa Leboa (South Africa)
     */
    nsoZA = 'nso-ZA',

    /**
     * Occitan (France)
     */
    ocFR = 'oc-FR',

    /**
     * Oriya (India)
     */
    orIN = 'or-IN',

    /**
     * Punjabi
     */
    pa = 'pa',

    /**
     * Punjabi (India)
     */
    paIN = 'pa-IN',

    /**
     * Polish
     */
    pl = 'pl',

    /**
     * Polish (Poland)
     */
    plPL = 'pl-PL',

    /**
     * Dari (Afghanistan)
     */
    prsAF = 'prs-AF',

    /**
     * Pashto (Afghanistan)
     */
    psAF = 'ps-AF',

    /**
     * Portuguese
     */
    pt = 'pt',

    /**
     * Portuguese (Brazil)
     */
    ptBR = 'pt-BR',

    /**
     * Portuguese (Portugal)
     */
    ptPT = 'pt-PT',

    /**
     * Kiche (Guatemala)
     */
    qutGT = 'qut-GT',

    /**
     * Quechua (Bolivia)
     */
    quzBO = 'quz-BO',

    /**
     * Quechua (Ecuador)
     */
    quzEC = 'quz-EC',

    /**
     * Quechua (Peru)
     */
    quzPE = 'quz-PE',

    /**
     * Romansh (Switzerland)
     */
    rmCH = 'rm-CH',

    /**
     * Romanian
     */
    ro = 'ro',

    /**
     * Romanian (Romania)
     */
    roRO = 'ro-RO',

    /**
     * Russian
     */
    ru = 'ru',

    /**
     * Russian (Russia)
     */
    ruRU = 'ru-RU',

    /**
     * Kinyarwanda (Rwanda)
     */
    rwRW = 'rw-RW',

    /**
     * Sanskrit
     */
    sa = 'sa',

    /**
     * Sanskrit (India)
     */
    saIN = 'sa-IN',


    /**
     * Yakut (Russia)
     */
    sahRU = 'sah-RU',

    /**
     * Sami (Northern) (Finland)
     */
    seFI = 'se-FI',

    /**
     * Sami (Northern) (Norway)
     */
    seNO = 'se-NO',

    /**
     * Sami (Northern) (Sweden)
     */
    seSE = 'se-SE',

    /**
     * Sinhala (Sri Lanka)
     */
    siLK = 'si-LK',

    /**
     * Slovak
     */
    sk = 'sk',

    /**
     * Slovak (Slovakia)
     */
    skSK = 'sk-SK',

    /**
     * Slovenian
     */
    sl = 'sl',

    /**
     * Slovenian (Slovenia)
     */
    slSI = 'sl-SI',

    /**
     * Sami (Southern) (Norway)
     */
    smaNO = 'sma-NO',

    /**
     * Sami (Southern) (Sweden)
     */
    smaSE = 'sma-SE',

    /**
     * Sami (Lule) (Norway)
     */
    smjNO = 'smj-NO',

    /**
     * Sami (Lule) (Sweden)
     */
    smjSE = 'smj-SE',

    /**
     * Sami (Inari) (Finland)
     */
    smnFI = 'smn-FI',

    /**
     * Sami (Skolt) (Finland)
     */
    smsFI = 'sms-FI',

    /**
     * Albanian
     */
    sq = 'sq',

    /**
     * Albanian (Albania)
     */
    sqAL = 'sq-AL',

    /**
     * Serbian
     */
    sr = 'sr',

    /**
     * Serbian (Cyrillic) (Bosnia and Herzegovina)
     */
    srCyrlBA = 'sr-Cyrl-BA',

    /**
     * Serbian (Cyrillic) (Serbia and Montenegro (Former))
     */
    srCyrlCS = 'sr-Cyrl-CS',

    /**
     * Serbian (Cyrillic) (Montenegro)
     */
    srCyrlME = 'sr-Cyrl-ME',

    /**
     * Serbian (Cyrillic) (Serbia)
     */
    srCyrlRS = 'sr-Cyrl-RS',

    /**
     * Serbian (Latin) (Bosnia and Herzegovina)
     */
    srLatnBA = 'sr-Latn-BA',

    /**
     * Serbian (Latin) (Serbia and Montenegro (Former))
     */
    srLatnCS = 'sr-Latn-CS',

    /**
     * Serbian (Latin) (Montenegro)
     */
    srLatnME = 'sr-Latn-ME',

    /**
     * Serbian (Latin) (Serbia)
     */
    srLatnRS = 'sr-Latn-RS',

    /**
     * Swedish
     */
    sv = 'sv',

    /**
     * Swedish (Finland)
     */
    svFI = 'sv-FI',

    /**
     * Swedish (Sweden)
     */
    svSE = 'sv-SE',

    /**
     * Kiswahili
     */
    sw = 'sw',

    /**
     * Kiswahili (Kenya)
     */
    swKE = 'sw-KE',

    /**
     * Syriac
     */
    syr = 'syr',

    /**
     * Syriac (Syria)
     */
    syrSY = 'syr-SY',

    /**
     * Tamil
     */
    ta = 'ta',

    /**
     * Tamil (India)
     */
    taIN = 'ta-IN',

    /**
     * Telugu
     */
    te = 'te',

    /**
     * Telugu (India)
     */
    teIN = 'te-IN',

    /**
     * Tajik (Cyrillic) (Tajikistan)
     */
    tgCyrlTJ = 'tg-Cyrl-TJ',

    /**
     * Thai
     */
    th = 'th',

    /**
     * Thai (Thailand)
     */
    thTH = 'th-TH',

    /**
     * Turkmen (Turkmenistan)
     */
    tkTM = 'tk-TM',

    /**
     * Setswana (South Africa)
     */
    tnZA = 'tn-ZA',

    /**
     * Turkish
     */
    tr = 'tr',

    /**
     * Turkish (Turkey)
     */
    trTR = 'tr-TR',

    /**
     * Tatar
     */
    tt = 'tt',

    /**
     * Tatar (Russia)
     */
    ttRU = 'tt-RU',

    /**
     * Tamazight (Latin) (Algeria)
     */
    tzmLatnDZ = 'tzm-Latn-DZ',

    /**
     * Uyghur (People's Republic of China)
     */
    ugCN = 'ug-CN',

    /**
     * Ukrainian
     */
    uk = 'uk',

    /**
     * Ukrainian (Ukraine)
     */
    ukUA = 'uk-UA',

    /**
     * Urdu
     */
    ur = 'ur',

    /**
     * Urdu (Islamic Republic of Pakistan)
     */
    urPK = 'ur-PK',

    /**
     * Uzbek
     */
    uz = 'uz',

    /**
     * Uzbek (Cyrillic) (Uzbekistan)
     */
    uzCyrlUZ = 'uz-Cyrl-UZ',

    /**
     * Uzbek (Latin) (Uzbekistan)
     */
    uzLatnUZ = 'uz-Latn-UZ',

    /**
     * Vietnamese
     */
    vi = 'vi',

    /**
     * Vietnamese (Vietnam)
     */
    viVN = 'vi-VN',

    /**
     * Wolof (Senegal)
     */
    woSN = 'wo-SN',

    /**
     * isiXhosa (South Africa)
     */
    xhZA = 'xh-ZA',

    /**
     * Yoruba (Nigeria)
     */
    yoNG = 'yo-NG',

    /**
     * Chinese (Simplified)
     */
    zhHans = 'zh-Hans',

    /**
     * Chinese (Traditional)
     */
    zhHant = 'zh-Hant',

    /**
     * Chinese (People's Republic of China)
     */
    zhCN = 'zh-CN',

    /**
     * Chinese (Hong Kong S.A.R.)
     */
    zhHK = 'zh-HK',

    /**
     * Chinese (Macao S.A.R.)
     */
    zhMO = 'zh-MO',

    /**
     * Chinese (Singapore)
     */
    zhSG = 'zh-SG',

    /**
     * Chinese (Taiwan)
     */
    zhTW = 'zh-TW',

    /**
     * isiZulu (South Africa)
     */
    zuZA = 'zu-ZA',
}